import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getActivityContainer = store =>
  import(/* webpackChunkName: "Activity" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "Activity" */ './containers/ActivityContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.ACTIVITY_LIST_PATH,
    ],
    component: AsyncComponent(() => getActivityContainer(store))
  }
])
